import React, { useState } from 'react';
import '../styles/SegmentWeCater.scss';

interface Segment {
    number: string;
    name: string;
    description: string;
}

interface Segments {
    segments: Segment[]
}
const Star = `${process.env.REACT_APP_S3_URL}triangle.svg`;
const OpenArrow = `${process.env.REACT_APP_S3_URL}OpenArrow.svg`;
const CloseArrow = `${process.env.REACT_APP_S3_URL}CloseArrow.svg`;
const SegmentsWeCaterTo: React.FC<Segments> = ({segments}) => {
    const [hoveredSegment, setHoveredSegment] = useState<string | null>(null);
    const [openIndex, setOpenIndex] = useState<number | null>(0);

    const toggleOpen = (index: number) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="segments-we-cater-to">
            {/* Header */}
            <h3 className="heading">
                <span style={{
                            background: 'linear-gradient(81.88deg, #E51A4B 0%, #E36F8A 107.04%)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            backgroundClip: 'text', // For Firefox
                            color: 'transparent',
                          }}>Segments</span> we cater to
            </h3>
            <p className="subheading">Tailored Solutions for Every Need</p>

            {/* Segment List */}
            <div className="segment-list-mobile">
                {segments.map((segment, index) => (
                    <div key={index} className="segment-item">
                    <div className="segment-header" onClick={() => toggleOpen(index)}>
                        <div className="segment-number">{segment.number}</div>
                        <div className="segment-name">{segment.name}</div>
                        <div className="segment-toggle">
                        {openIndex === index ? (
                            <img src={CloseArrow} alt="x" />
                        ) : (
                            <img src={OpenArrow} alt="x" />
                        )}
                        </div>
                    </div>
                    {openIndex === index && (
                        <div className="segment-description">
                        <img className="icon" src={Star} alt="" />
                        <div>{segment.description}</div>
                        </div>
                    )}
                    </div>
                ))}
            </div>
            <div className="segment-list">
                {segments.map((segment, index) => (
                    <div
                        key={index}
                        className={`segment-item ${hoveredSegment === segment.name ? 'hovered' : ''}`}
                        onMouseEnter={() => setHoveredSegment(segment.name)}
                        onMouseLeave={() => setHoveredSegment(null)}
                    >
                        <div style={{ display: 'flex', flex:1, alignItems: 'center' }}>
                            <div className="segment-number">{segment.number}</div>
                            <div className="segment-name">{segment.name}</div>
                        </div>
                        {
                        hoveredSegment === segment.name && (
                            <div className="segment-description">
                                <img className='icon' src={Star} alt='' />
                                {segment.description}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SegmentsWeCaterTo;
